import { IAuthResponse } from '@/features/account/api/auth.interfaces';
import axios from 'axios';
import {
  IResetPassword,
  IUserRegistration,
  ILoginCredentials,
  IEmailConfirmation,
  IRefreshCredentials,
  IChangePassword,
} from './auth.interfaces';
import { BaseService } from '@/features/base/api/base.api';

class AuthService extends BaseService {
  private static instance: AuthService;

  private constructor() {
    super();
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public login(credentials: ILoginCredentials): Promise<IApi<IAuthResponse>> {
    return this.postItem<IAuthResponse>(`${this.baseUrl}/api/auth/login`, credentials);
  }

  public logout(refreshToken: string): Promise<IApi<String>> {
    return this.postItem<String>(`${this.baseUrl}/api/auth/logout`, { refresh_token: refreshToken });
  }

  public refresh(credentials: IRefreshCredentials): Promise<IApi<IAuthResponse>> {
    return this.postItem<IAuthResponse>(`${this.baseUrl}/api/auth/login`, credentials);
  }

  public register(register: IUserRegistration): Promise<IApi<string>> {
    return this.postItem<string>(`${this.baseUrl}/api/auth/register`, register);
  }

  public confirmEmail(confirm: IEmailConfirmation): Promise<IApi<string>> {
    return this.postItem<string>(`${this.baseUrl}/api/auth/confirm`, confirm);
  }

  public sendResetPassword(email: string): Promise<IApi<string>> {
    return this.postItem<string>(`${this.baseUrl}/api/auth/forgotpassword`, {
      email,
    });
  }

  public resetPassword(reset: IResetPassword): Promise<IApi<string>> {
    return this.postItem<string>(`${this.baseUrl}/api/auth/resetpassword`, reset);
  }

  public changePassword(changePassword: IChangePassword): Promise<IApi<string>> {
    return this.postItem<string>(`${this.baseUrl}/api/auth/changepassword`, changePassword);
  }

  public generateCode(email: string): Promise<IApi<string>> {
    return this.get<string>(`${this.baseUrl}/api/auth/generatecode?email=${email}`);
  }
}

export const authService = AuthService.Instance;
